import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const navBtnOpen = document.querySelector('.navigation__humb--open');
const navBtnClose = document.querySelector('.navigation__humb--close');
const navSp = document.querySelector('.navigation__sp');
const body = document.querySelector('html');
const followingHeader = document.querySelector('.l-header__following');
const blockContainer = document.querySelector('.blockContainer');

class Nav {
  openFlag = false;

  constructor() {
    this.events();
    this.followHeader();
  }

  // イベント
  events() {
    navBtnOpen.addEventListener('click', this.onClickDispatcher.bind(this));
    navBtnClose.addEventListener('click', this.onClickDispatcher.bind(this));
  }

  // メソッド
  onClickDispatcher() {
    if (this.openFlag === false) {
      this.navOpen();
    } else if (this.openFlag === true) {
      this.navClose();
    }
  }

  navOpen() {
    console.log('hi');
    const TL = gsap.timeline();
    TL.to(navSp, {
      autoAlpha: 1,
      x: '0%',
      duration: 0.4,
      ease: 'power4.out',
    })
      .add(() => body.classList.add('body-no-scroll'))
      .add(() => navBtnOpen.classList.remove('active'))
      .add(() => navBtnClose.classList.add('active'));
    this.openFlag = true;
  }
  navClose() {
    const TL2 = gsap.timeline();
    TL2.to(navSp, {
      autoAlpha: 0,
      x: '-100%',
      duration: 0.4,
      ease: 'power4.out',
    })
      .add(() => body.classList.remove('body-no-scroll'))
      .add(() => navBtnClose.classList.remove('active'))
      .add(() => navBtnOpen.classList.add('active'));
    this.openFlag = false;
  }

  followHeader() {
    gsap.to(followingHeader, {
      top: 0,
      duration: 0.3,
      scrollTrigger: {
        trigger: blockContainer,
        start: 'top top',
        end: 'bottom top',
        onEnter: () => {
          gsap.to(followingHeader, {
            top: '0%',
            duration: 0.3,
          });
        },
        onLeaveBack: () => {
          gsap.to(followingHeader, {
            top: '-100%',
            duration: 0.3,
          });
        },
      },
    });
  }
}

export default Nav;
